// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

import $ from 'jquery';

import Svg from '../_modules/svg/svg';
import Slider from '../_modules/slider/slider';
import Gallery from '../_modules/gallery/gallery';
import 'browsernizr/test/css/objectfit';
import Modernizr from 'browsernizr';

$(() => {
  const svgs = document.querySelectorAll('body .svg');
  svgs.forEach(svg => new Svg(Modernizr.svg, svg));

  const sliders = document.querySelectorAll('body .slider');
  sliders.forEach(slider => new Slider(slider));

  const galleries = document.querySelectorAll('body .gallery');
  galleries.forEach(gallery => new Gallery(gallery));
});
